export { CmsEntryOpenSearchFullTextSearch } from "./abstractions.js";
